import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { ContentSpacing, breakpoint } from 'elc-base-theme';
import { ITrendingTermItem } from '../../interfaces/ISearchInterfaces';
import {
    SEARCH_VIEW,
    PREDICTIVE_SEARCH_PARAM,
    STANDARD_SEARCH_PARAM,
    TRENDING_SEARCH_PARAM,
    SEARCH_PARAM,
    SEARCH_TYPE_PARAM,
    SEARCH_TYPE_PARAM_EXTERN
} from '../../../internal/constants/Search';
import { classes } from '../../utils/Classes';

const TrendingTermWrapper = styled.ul`
    display: flex;
    flex-direction: column;
    padding: ${ContentSpacing.space10} 0;
    width: auto;
    ${breakpoint('desktop')`
        padding: ${ContentSpacing.space20} ${ContentSpacing.space24} 0;
    `};
`;

const TrendingTermLink = styled.a`
    display: inline-block;
    margin: 0;
    max-width: 400px;
    overflow: hidden;
    vertical-align: middle;
`;

const TrendingTermTitle = styled.p`
    margin-bottom: ${ContentSpacing.space16};
`;

export interface ISearchTrendingTerm {
    trendingTerm: ITrendingTermItem;
    searchUrl?: string;
    view: number;
}

@observer
export class SearchTrendingTerm extends React.Component<ISearchTrendingTerm> {
    private searchTrendingTermWrapper = classes('search-trending-term-wrapper');
    private searchTrendingTermTitle = classes('search-trending-term-title');
    private searchTrendingTermLink = classes('search-trending-term-link');

    public render() {
        const { trendingTerm, searchTerm } = this.props.trendingTerm;
        let { link } = this.props.trendingTerm;
        const { searchUrl, view } = this.props;

        let searchType;

        if (view === SEARCH_VIEW.ENHANCED_SEARCH_OVERLAY) {
            searchType = `${PREDICTIVE_SEARCH_PARAM}${TRENDING_SEARCH_PARAM}`;
        } else {
            searchType = `${STANDARD_SEARCH_PARAM}_${TRENDING_SEARCH_PARAM}`;
        }

        if (!!searchTerm && searchTerm !== '') {
            link = `${searchUrl}${SEARCH_PARAM}${searchTerm}${SEARCH_TYPE_PARAM}${searchType}`;
        } else if (!!link && link !== '') {
            link += `${SEARCH_TYPE_PARAM_EXTERN}${searchType}`;
        } else {
            link = '';
        }

        return (
            <TrendingTermWrapper className={this.searchTrendingTermWrapper}>
                <TrendingTermTitle className={this.searchTrendingTermTitle}></TrendingTermTitle>
                <TrendingTermLink
                    className={this.searchTrendingTermLink}
                    href={link}
                    title={trendingTerm}
                    aria-label={trendingTerm}
                    data-test-id={`SEA-Search-${trendingTerm}`}
                >
                    {trendingTerm}
                </TrendingTermLink>
            </TrendingTermWrapper>
        );
    }
}
